import { type VariantProps, cva } from 'class-variance-authority'

export { default as Badge } from './Badge.vue'

export const badgeVariants = cva(
  'inline-flex items-center justify-center rounded-lg px-2.5 py-1 text-xs tracking-wider ring-1 ring-inset',
  {
    variants: {
      variant: {
        default: 'text-gray-900 ring-gray-700/40 dark:text-gray-100 dark:ring-gray-300/40',
        secondary: 'bg-blue-400/20 text-blue-900 ring-blue-700/40 dark:bg-blue-400/10 dark:text-blue-200 dark:ring-blue-500/40',
        success: 'bg-lime-400/20 text-lime-900 ring-lime-700/40 dark:bg-lime-400/10 dark:text-lime-200 dark:ring-lime-500/40',
        destructive: 'bg-rose-400/20 text-rose-900 ring-rose-700/40 dark:bg-rose-400/10 dark:text-rose-200 dark:ring-rose-500/40',
        outline: 'text-gray-950 dark:text-gray-100',
        'outline-danger': 'text-gray-950 hover:bg-rose-100 dark:text-gray-100 dark:hover:bg-rose-200/10',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
)

export type BadgeVariants = VariantProps<typeof badgeVariants>
